module.exports = __webpack_public_path__ + "static/media/first-page-slide2.13063f6c.jpg";